export const URL_PATH = '/globalcredit/public/pdf/';
export const URL_PILLS_DOCUMENTATION = '/globalcredit/public/pildoras_documentacion/';
export const COMUNICATIONS_PRINT_AC1 = 'Formulario_datos_clientes_particulares.pdf';
export const COMUNICATIONS_PRINT_AC2 = 'Formulario_datos_comunidades_de_propietarios.pdf';
export const COMUNICATIONS_PRINT_AA = 'Solicitud_de_credito_asalariados_autonomos_AUTO.pdf';
export const COMUNICATIONS_PRINT_AC = 'Solicitud_de_credito_asalariado_autonomo_CONSUMO.pdf';
export const COMUNICATIONS_PRINT_EA = 'Solicitud_de_credito_empresa_AUTO.pdf';
export const COMUNICATIONS_MANUAL_GC_TRAD = 'Manual GlobalCredit_Operativa Tradicional.pdf';
export const COMUNICATIONS_TRANSPARENCY = 'SCONSUMER%20TRANSPARENCIA_CAS.pdf';
export const COMUNICATIONS_PAYMENTMANUAL = 'Manual_Conceptual_Pagos_SCF.pdf';
export const COMUNICATIONS_LIFEMANUAL = 'Manual_Conceptual_Vida_SCF.pdf';
export const DOWNLOAD = 'download';
export const VIEW = 'view';
export const URL_SPEED_TEST = 'https://www.testdevelocidad.es/';
export const URL_TUTORIAL_PROVIDER_ALLOWED_YOUTUBE = 'youtube.com';
export const URL_TUTORIAL_PROVIDER_ALLOWED_VIMEO = 'vimeo.com';
export const URL_TUTORIAL_PROVIDER_ALLOWED_KALTURA = 'cdnapisec.kaltura.com';
export const URL_ROOT = '/';
export const URL_HTTPS_PROTOCOL = 'https://';
